import { Recipient } from '@bonusly/recipient-entities';

import { EmployeeSpotlightAttachment, ImageAttachment, SocialAttachment, VideoAttachment } from '../../action-input/lib/entities/attachment';

export enum GiveBoxEvent {
	Created = 'bonus-created',
	Deleted = 'bonus-deleted',
	Open = 'init-give-recognition',
}

export type GiveBoxAttachment = SocialAttachment | ImageAttachment | VideoAttachment | EmployeeSpotlightAttachment;

// Type definition for GiveBoxEvent.Open event data
export interface GiveBoxOpenEventData {
	recipient?: Recipient;
	text?: string;
	amount?: number;
	hashtags?: string[];
	attachment?: GiveBoxAttachment;
}
